import FloatingVideoButton from '../../commons/buttons/FloatingVideoButton';
import MenuTitle from '../../commons/menu/MenuTitle';
import ReportDetailItem from './components/ReportDetailItem';

function ReportDetail() {
  const items = [
    { name: 'Geral', path: 'relatorio-geral' },
    { name: 'Serviços', path: 'relatorio-servico' },
    { name: 'Clientes', path: 'relatorio-cliente' },
  ];

  return (
    <div className="container">
      <MenuTitle title="Relatórios" />

      <div className="row g-3 mt-1">
        {items.map((it) => (
          <div key={it.path} className="col-12 col-md-6 col-lg-4">
            <ReportDetailItem name={it.name} path={it.path} />
          </div>
        ))}
      </div>
      <FloatingVideoButton isSecondFloatingButton={false} youtubeUrl={"https://youtube.com/embed/41cBXxTw69I"} />

    </div>
  );
}

export default ReportDetail;